import { AccountInfo } from '@azure/msal-browser'
import React, { useState } from 'react'
import Icon from '../svg/Icon'
import BookmarkMyAccount from './BookmarkMyAccount'
import Conditional from './Conditional'
import Feedback from './Feedback'

export interface IFooterToolsProps {
  title?: string
  activeAccount?: AccountInfo
  handleClick?: (status: boolean) => void
}
const FooterTools = (props: IFooterToolsProps) => {
  const [showBookmarkButton, setShowBookmarkButton] = useState({
    visible: false,
  })
  const ospBaseUrl = process.env.REACT_APP_REDIRECT_URI
  const query = new URLSearchParams()
  query.append('System', 'Web')
  query.append('Title', props.title)
  query.append('SourceUrl', window.location.href)
  const url = ospBaseUrl + '/BookmarkToMyAccount?' + query.toString()

  const handleBookmarkToMyAccount = () => {
    if (props.activeAccount) {
      window.location.href = url
    } else {
      setShowBookmarkButton((prevState) => ({
        ...prevState,
        visible: !showBookmarkButton.visible,
      }))
    }
  }

  return (
    <div className="region-footer-tools">
      <Feedback />

      <div className="dropdown-container">
        <a
          aria-haspopup="true"
          className="js-dropdown-trigger"
          onClick={handleBookmarkToMyAccount}
          role="button"
          tabIndex={0}
          onKeyUp={(event) => {
            if (event?.keyCode == '13') {
              handleBookmarkToMyAccount()
            }
          }}
        >
          <Icon name="save" />
          Bookmark to my account
        </a>

        <Conditional if={showBookmarkButton.visible}>
          <BookmarkMyAccount
            title={props.title}
            activeAccount={props.activeAccount}
          />
        </Conditional>
      </div>
    </div>
  )
}

export default FooterTools
